"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reducer = _interopRequireDefault(require("settings-ui-sdk/Products/reducer"));

var _queryReducer = _interopRequireDefault(require("settings-ui-sdk/Products/queryReducer"));

var _editReducer = _interopRequireDefault(require("settings-ui-sdk/Products/editReducer"));

var _editableTotalReducer = _interopRequireDefault(require("settings-ui-sdk/Products/editableTotalReducer"));

var _reducer2 = _interopRequireDefault(require("settings-ui-sdk/QuoteAutomation/reducer"));

var _reducer3 = _interopRequireDefault(require("settings-ui-sdk/QuoteApproval/reducer"));

var _default = (0, _redux.combineReducers)({
  productsAndFolders: _reducer.default,
  quoteAutomation: _reducer2.default,
  quoteApproval: _reducer3.default,
  query: _queryReducer.default,
  edit: _editReducer.default,
  editableTotal: _editableTotalReducer.default
});

exports.default = _default;
module.exports = exports.default;